export const langColors = {
    javascript: '#f1c40f',
    typescript: '#2980b9',
    python: '#2ecc71',
    html: '#e67e22',
    css: '#9b59b6',
    scss: '#9b59b6',
    vue: '#1abc9c',
    php: '#3498db',
    go: '#72aed8',
    ruby: '#e74c3c',
    c: '#16a085',
    'c#': '#27ae60',
    'c++': '#7f8c8d',
    java: '#b07219'
}